import localeData from './helpers/login.lang'
import {oneSecondMilliseconds, loginModes} from './helpers/login.data'

const language = 'en'
const locale = localeData[language]
const {
  createNewPassword,
  forgotPassword,
  normal,
  renewExpiredPassword,
  tfaCode,
  audit,
  forgottenPasswordLinkExpired
} = loginModes

const isModeOneOf = ({mode, modes}) => modes.includes(mode)

const extractInstanceProps = ({type, name}) => ({
  prod: (type === 'prod'),
  environment: ((type === 'prod') ? 'production' : 'staging'),
  solutionName: name
})

const checkPasswordPolicyViolation = ({password, passwordPolicy}) => {
  const {
    minLength,
    minLowercase,
    minUpperCase,
    minNumbers,
    minSpecial
  } = passwordPolicy
  if (minLength && (password.length < minLength)) {
    return locale.passwordPolicyNotMetLength(minLength)
  }
  if (minLowercase && (password.replace(/[^a-z]/g, '').length < minLowercase)) {
    return locale.passwordPolicyNotMetLowercase(minLowercase)
  }
  if (minUpperCase && (password.replace(/[^A-Z]/g, '').length < minUpperCase)) {
    return locale.passwordPolicyNotMetUppercase(minUpperCase)
  }
  if (minNumbers && (password.replace(/\D/g, '').length < minNumbers)) {
    return locale.passwordPolicyNotMetNumber(minNumbers)
  }
  if (minSpecial && (password.replace(/[a-zA-Z0-9]/g, '').length < minSpecial)) {
    return locale.passwordPolicyNotMetSpecial(minSpecial)
  }
  return false
}

const onStartUp = ({mode, hasAuthFailed, username, onGetInstanceProperties, onGetPasswordPolicy, onGetSsoInformation, onRequestCode, onEnableRequestingNewCode}) => {
  onGetSsoInformation()
  onGetInstanceProperties()

  if (isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]})) {
    onGetPasswordPolicy()
  }
  if (mode === tfaCode) {
    if (hasAuthFailed) {
      onEnableRequestingNewCode()
    }
    else {
      onRequestCode({username})
    }
  }
}

const onSubmit = ({mode, username, password, confirmPassword, passwordPolicy, secretCode, onAuthenticate, onAuthenticateFactorTwo, onRequestNewPassword, onSetNewPassword, onSubmitAuditMessage, isTFAEnabled, hasTFACookie, TFAChannel, auditMessage}) => {
  if (mode === normal) {
    onAuthenticate({username, password})
  }
  else if (mode === tfaCode) {
    onAuthenticateFactorTwo({username, twoFactorCode: secretCode})
  }
  else if (isModeOneOf({mode, modes: [forgotPassword, forgottenPasswordLinkExpired]})) {
    onRequestNewPassword({username})
  }
  else if (isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]})) {
    onSetNewPassword({username, password, confirmPassword, passwordPolicy, isTFAEnabled, hasTFACookie, TFAChannel})
  }
  else if (mode === audit) {
    onSubmitAuditMessage({auditMessage})
  }
}

const getTimeWithDelay = seconds => Date.now() + (seconds * oneSecondMilliseconds)

const getSecondsLeft = endTime => (endTime - Date.now()) / oneSecondMilliseconds

const doesCookieExist = query => (query && document.cookie.split(';').filter(item => item.includes(`${query}=`)).length > 0)

export {
  isModeOneOf, extractInstanceProps, checkPasswordPolicyViolation, onStartUp, onSubmit, getTimeWithDelay, getSecondsLeft, doesCookieExist
}
